import { useEffect } from 'react';

const handleItemClick = ({ currentTarget }) => {
  const sectionWrapper = currentTarget.closest('.documents-for-download__item');
  const selectValue = sectionWrapper
    .querySelector('.documents-for-download-select__value')
    .querySelector('span');
  const activeItem = sectionWrapper.querySelector('.documents-for-download-select__item_active');

  sectionWrapper
    .querySelector('.documents-for-download__button')
    .setAttribute('href', currentTarget.getAttribute('data-document'));

  selectValue.innerHTML = currentTarget.innerHTML;

  if (currentTarget !== activeItem) {
    activeItem.classList.remove('documents-for-download-select__item_active');
    activeItem.removeAttribute('aria-selected');
    currentTarget.classList.add('documents-for-download-select__item_active');
    currentTarget.setAttribute('aria-selected', true);
  }
};

const handleDropdownMenuClick = ({ target }) => {
  const dropdownMenuWrapper = document.querySelectorAll('.documents-for-download-select');

  dropdownMenuWrapper.forEach((item) => {
    const dropdownMenu = item.querySelector('.documents-for-download-select__item-dropdown');
    if (dropdownMenu) {
      if (item.contains(target) && !dropdownMenu.contains(target)) {
        dropdownMenu.classList.add('documents-for-download-select__item-dropdown_active');
      } else {
        dropdownMenu.classList.remove('documents-for-download-select__item-dropdown_active');
      }
    }
  });
};

export default function useDocumentsDownload() {
  useEffect(() => {
    const items = document.querySelectorAll('.documents-for-download-select__item');

    items.forEach((item) => item.addEventListener('click', handleItemClick));
    document.addEventListener('click', handleDropdownMenuClick);

    return () => {
      items.forEach((item) => item.removeEventListener('click', handleItemClick));
      document.removeEventListener('click', handleDropdownMenuClick);
    };
  }, []);
}
